import { Skeleton } from '@/common/components/ui/skeleton';

export const DetailsPageSkeleton = () => {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-1">
        <Skeleton className="h-8 max-w-[400px] w-full" />
        <Skeleton className="h-5 max-w-[300px] w-full" />
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Skeleton className="h-[250px] rounded-lg" />
        <Skeleton className="h-[250px] rounded-lg" />
        <Skeleton className="h-[250px] rounded-lg" />
        <div className="col-span-2">
          <Skeleton className="h-[300px] rounded-lg" />
        </div>
      </div>
    </div>
  );
};
